export default {
    modalShowImageVariations: {
        imageAi: 'Beeld AI',
        regenerateImage: 'Geneer nieuwe content',
        description: 'Omschrijving',
        style: 'Stijl',
        saveToLibrary: 'Opslaan in bibliotheek',
        continue: 'Doorgaan',
        cancel: 'Annuleer',
        select: 'Selecteren',
        copy: 'Kopie',
        selectedImage: 'Geselecteerde afbeelding',
        saved: 'Opgeslagen',
        variations: 'Varianten',
    },
};
